<template>
  <div class="one-column-width">
    <!-- show action result -->
    <v-snackbar v-model="snackbar" absolute top right color="success">
      <span>{{ snackBarText }}</span>
      <v-icon dark>mdi-checkbox-marked-circle</v-icon>
    </v-snackbar>

    <v-snackbar v-model="errorMessage" absolute top right color="danger">
      <span>Something went RONG, Please Try Again!</span>
      <v-icon dark>mdi-checkbox-marked-circle</v-icon>
    </v-snackbar>

    <!-- Confirm Delete Item -->

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="380px">
        <v-card>
          <v-card-title>
            <span class="headline">Do you really want to DELETE this item?</span>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="custom-submit-button" text @click="dialog = false">No</v-btn>
            <v-btn class="custom-cancel-button" text @click="deleteItem"
              ><b-spinner small type="grow" v-if="deleting"></b-spinner>Delete</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    

    <!-- table start -->
    <v-card class="r_tabsform_card">
      <v-card-title class="r_form_card_title">
        Admission Form Tabs
        <!-- <div class="my-2 ml-2">
          <v-btn
            class="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
            fab
            small
            @click="showForm"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </div> -->
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          class="r_form_top_search"
          append-icon="search"
          label="Search tabs"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <hr class="r_form_card_top_hr">
      <v-data-table :headers="headers" :items="tableData" :search="search">
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            class="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
            fab
            small
            @click="showEditForm(item)"
          >
            <v-icon dark>mdi-pencil</v-icon>
          </v-btn>
          &nbsp;
          <v-btn
            class="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5 my-1"
            fab
            small
            @click="askUserAboutDelete(item)"
          >
            <v-icon dark>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <div class="r_form_add_more_btnnn_div">
        <button @click="showForm" class="r_form_add_more_btnnn">Add new tab</button>
      </div>
    </v-card>

    <!-- table end -->

    <!-- form start -->
    <v-card class="add-form-title r_tabsform_card" v-if="showFormData">
      <v-card-title class="r_form_card_title"> Add New Admission Form Tab </v-card-title>
      <hr class="r_form_card_top_hr">
      <div>
        <v-form ref="form" @submit.prevent="submit" class="">
          <v-container fluid>
            <v-col cols="12" sm="8">
              <v-row v-for="(item, index) in form" :key="index">
                <input
                  type="text"
                  v-model="item.caption"
                  :rules="rules.caption"
                  color="purple name-2"
                  class="r_formtabs_inputs"
                  placeholder="Caption"
                  required
                >
                <input
                  v-model="item.name"
                  :rules="rules.name"
                  color="purple name-2"
                  placeholder="Tab Name"
                  class="r_formtabs_inputs"
                  required
                >
                <input
                  v-model="item.sequence"
                  :rules="rules.sequence"
                  color="purple name-2"
                  placeholder="sequence"
                  class="r_formtabs_inputs"
                  required
                >
                <template v-if="!editId">
                  <button
                    class="r_form_add_more_recods_btnnn"
                    type="button"
                    @click="addNewRow()"
                    >Add new</button
                  >
                  <button
                    v-if="index > 0"
                    class="r_cust_del_new_rec_btn"
                    type="button"
                    @click="deleteRow(index)"
                    >Delete</button
                  >
                </template>
              </v-row>
            </v-col>
          </v-container>
          <v-card-actions>
            <button
              :disabled="$v.$invalid || submitting"
              class="r_form_add_more_btnnn"
              type="submit"
              ><b-spinner small type="grow" v-if="submitting"></b-spinner>
              <span v-if="!editId">Submit tabs</span>
              <span v-if="editId">Update tab</span>
            </button>
            <button text @click="cancelForm" class="r_form_cancel_more_btnnn">Cancel</button>
          </v-card-actions>
        </v-form>
      </div>
    </v-card>
    <!-- form end -->
  </div>
</template>

<script>
import AdmissionForm from "@/MainServices/AdmissionForm.js";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      form: [{ caption: "", name: "", sequence: null }],
      editId: null,
      deleteId: null,
      dialog: false,
      rules: {
        caption: [(val) => (val || "").length > 0 || "Caption is required"],
        name: [(val) => (val || "").length > 0 || "Name is required"],
        sequence: [(val) => (val || "").length > 0 || "Sequence is required"],
      },
      snackbar: false,
      snackBarText: null,
      submitting: false,
      deleting: false,
      errorMessage: false,
      search: "",
      showFormData: false,
      headers: [
        {
          text: "Caption",
          align: "left",
          sortable: false,
          value: "caption",
          width: "30%",
          class: "r_c_formtabs_heading"
        },
        { text: "Name", align: "left", sortable: false, value: "name", width: "30%", class: "r_c_formtabs_heading" },
        {
          text: "Sequence",
          align: "left",
          sortable: false,
          value: "sequence",
          width: "30%",
          class: "r_c_formtabs_heading"
        },
        { text: "Actions", value: "actions", sortable: false, class: "r_c_formtabs_heading" },
      ],
      tableData: [],
    };
  },
  validations: {
    form: {
      required,
      $each: {
        caption: { minLength: minLength(1), required },
        name: { minLength: minLength(1), required },
        sequence: { minLength: minLength(1), required },
      },
    },
  },
  components: {},

  computed: {},

  methods: {
    getInititalData() {
      AdmissionForm.getFormTabs()
        .then((res) => {
          this.tableData = res.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // main methods
    showForm() {
      this.editId = null;
      this.showFormData = true;
      this.resetForm();
    },
    showEditForm(item) {
      this.form = [{ caption: item.caption, name: item.name, sequence: item.sequence }];
      this.editId = item.id;
      this.showFormData = true;
    },
    cancelForm() {
      this.resetForm();

      this.showFormData = false;
    },
    resetForm() {
      this.form = [{ caption: "", name: "", sequence: null }];
      this.editId = null;
      setTimeout(() => {
        this.$refs.form.reset();
      }, 100);
    },
    addNewRow() {
      this.form.push({ caption: "", name: "", sequence: null });
    },
    deleteRow(index) {
      this.form.splice(index, 1);
    },
    submit() {
      this.submitting = true;
      if (this.editId) {
        AdmissionForm.editTab(this.form, this.editId)
          .then((res) => {
            this.resetForm();
            this.getInititalData();
            this.submitting = false;
            this.snackBarText = "Tabs Updated successful!";
            this.snackbar = true;
          })
          .catch((error) => {
            this.errorMessage = true;
          });
      } else {
        AdmissionForm.addNewTabs(this.form)
          .then((res) => {
            this.resetForm();
            this.getInititalData();
            this.submitting = false;
            this.snackBarText = "Tabs Added successful!";
            this.snackbar = true;
          })
          .catch((error) => {
            this.errorMessage = true;
          });
      }
    },
    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },
    deleteItem() {
      this.deleting = true;
      AdmissionForm.deleteTab(this.deleteId)
        .then((res) => {
          this.editId = null;
          this.deleting = false;
          this.dialog = false;
          this.resetForm();
          this.getInititalData();
          this.snackBarText = "Tab Deleted successful!";
          this.snackbar = true;
        })
        .catch((error) => {
          this.errorMessage = true;
          this.dialog = false;
        });
    },
  },
  mounted() {
    this.getInititalData();
  },
};
</script>

<style scoped>
/* .add-form-title {
  margin-top: 20px !important;
}
.r_tabsform_card.v-card.v-sheet.theme--light {
    border-radius: 10px !important;
}
.v-card__title.r_form_card_title {
    color: #2262A9 !important;
    font-weight: 900 !important;
    font-size: 19px !important;
}
hr.r_form_card_top_hr {
    margin: 0 !important;
    border-top: 2px solid #CBF2E1 !important;
}
.r_form_add_more_btnnn_div {
    padding: 5px 40px 20px 40px!important;
}
button.r_form_add_more_btnnn {
    background: #1C5AA5 !important;
    color: white !important;
    padding: 10px 40px !important;
    border-radius: 2rem !important;
    font-weight: bold !important;
}
.v-input.r_form_top_search.v-input--hide-details.theme--light.v-text-field.v-text-field--single-line.v-text-field--is-booted {
    border: 1px solid black !important;
    border-radius: 2rem !important;
    padding: 0px 20px !important;
    width: 10%;
}
.v-input.r_form_top_search.v-input--hide-details.theme--light.v-text-field.v-text-field--single-line.v-text-field--is-booted::after {
  border: none !important;
}
button.r_form_add_more_recods_btnnn {
    background: #1C5AA5 !important;
    color: white !important;
    padding: 5px 10px !important;
    border-radius: 2rem !important;
    font-weight: bold !important;
    height: 50% !important;
}
button.r_cust_del_new_rec_btn {
    background: #A82511 !important;
    color: white !important;
    padding: 5px 10px !important;
    border-radius: 2rem !important;
    font-weight: bold !important;
    height: 50% !important;
    margin-left: 10px !important;
}
button.r_form_cancel_more_btnnn {
    background: #A82511 !important;
    color: white !important;
    padding: 10px 40px !important;
    border-radius: 2rem !important;
    font-weight: bold !important;
    height: 50% !important;
    margin-left: 10px !important;
}
input.r_formtabs_inputs {
    border: 1px solid black !important;
    height: 35px !important;
    border-radius: 2rem !important;
    padding: 0 10px !important;
    margin-right: 15px !important;
    margin-bottom: 15px !important;
} */
</style>
